import type { ReactNode } from "react";
import { NotificationsContext, useNotificationsSource } from "@/hooks/use-notifications";

/**
 * Owns the one notification feed for the signed-in shell.
 *
 * Mounted once by `AppLayout`, above both the topbar bell and the route
 * content, so the bell's unread badge and the `/notifications` page are two
 * views of the same rows: marking a row read on the page moves the badge, and
 * "Mark all as read" in either place is reflected in the other. Before this the
 * two surfaces each owned a private feed and could disagree until a reload
 * (review fix 2, ALL-5825 W3).
 *
 * Consumers keep calling `useNotifications()`; nothing else changes for them.
 * Outside a provider (unit tests that render a single surface, the design lab)
 * that hook falls back to its own private feed, which is what it did before.
 */
export function NotificationsProvider({ children }: { children: ReactNode }) {
  const value = useNotificationsSource(true);
  return <NotificationsContext.Provider value={value}>{children}</NotificationsContext.Provider>;
}
